<template>
  <div class="side-panel absolute top-0 right-0 w-full h-full max-w-3xl bg-white border-l bg-gray-50">
    <div class="flex justify-between px-8 py-4 border-b bg-white">
      <h2 class="text-xl leading-none">Saved Specialty Color Calculations</h2>
      <img @click="close" class="h-4 inline-block mt-1 cursor-pointer opacity-50 hover:opacity-100" src="../assets/icons/close-icon.svg" />
    </div>
    <div class="pb-8">
      <p class="px-8" v-if="loading">Loading Records...</p>
      <p class="px-8 py-2" v-if="!loading && !projects.length">There are no saved calculations for this profile.</p>
      <div class="">
          <div v-for="project in projects" :key="project.id" class="border-b py-2 cursor-pointer hover:bg-gray-100" @click="loadProject(project)">
            <div class="flex justify-between items-center px-8 relative">


                <div>
                  <p class="leading-none border-b border-transparent">{{ project.projectName }}</p>
                  <p class="text-sm flex items-center leading-relaxed"><span class="inline-block mr-2 w-3 h-3 bg-black border" :style="colorStyles[project.color]"></span>{{ project.color }} – {{ project.impressions }} impressions</p>
                  <p class="text-xs opacity-50 border-t border-transparent">{{ project.ts | formatTS }}</p>
                </div>



              <p>{{ project.totalCost | currency }} <img class="inline-block h-3 ml-2" src="../assets/icons/chevron-right-icon.svg" /></p>
            </div>


          </div>

      </div>
    </div>



  </div>
</template>

<script>



export default {
  name: "side-panel-color-calcs",
  components: {},
  mounted() {
     this.loadProjects();
  },

  data: function () {
    return {
      projects: [],
      loading: true
    }
  },
  methods: {
    close: function(){
      this.$emit('close');
    },

    loadProject: function(project){
      this.$emit('load', project);
    },

    loadProjects: function(){
        this.loading = true;
        this.$colorCalc.loadColorCalcsForProfile(this.profile.userid).then((response) => {
          //console.log(response);
          this.loading = false;
          this.projects = response.data.map((project) => {

            return project.data
          }).sort((a,b)=>{
            return (b.ts - a.ts)
          })
        })
      .catch((error) => {
        console.error("Error", error);
        this.loading = false;
        alert("Records could not be loaded. Refresh and try again.");
      })
    }
  },
  computed: {
    profile: function(){
      return this.$store.getters.getUserProfile;
    },

    colorStyles: function(){

      return {
        "Invisible Red": { backgroundColor: 'red' },
        "Clear": { backgroundColor: 'transparent' },
        "White": { backgroundColor: 'white' },
        "Neon Yellow": { backgroundColor: 'yellow' },
        "Neon Pink": { backgroundColor: 'hotpink' },
      }

    }
  }
}
</script>

<style scoped>


.side-panel-new-assessment {

}

</style>